export const AT_DATES_FILTER_SET = 'GANTT_VIEW_DATES_FILTER_SET';
export const AT_HIDE_EMPTY_DATES_SET = 'GANTT_VIEW_HIDE_EMPTY_DATES_SET';
export const AT_GANTT_UPDATE = 'GANTT_VIEW_UPDATE';
